export default {
  SET_SERVICE_CONFIG: '@WS/SET_SERVICE_CONFIG',
};
